<div
  class="input-wrapper"
  [formGroup]="form"
  [ngSwitch]="type"
  [class.disabled]="isDisabled"
  [class.has-error]="form.get(controlName)?.invalid && form.get(controlName)?.touched"
>
  <label
    *ngIf="type !== InputFieldType.Switch && showLabel"
    [class.required]="form.get(controlName)?.hasValidator(Validators.required)"
    [class.checkbox-label]="type === InputFieldType.Checkbox"
    [for]="inputId"
    class="form-label"
  >
    {{ label | allLettersCapital }}
    <i *ngIf="optionsLoading" class="fa-spin fas fa-spinner mx-2"></i>

    <app-info-icon
      *ngIf="labelTooltip"
      [tooltip]="labelTooltip"
    ></app-info-icon>
  </label>
  <ng-container *ngSwitchCase="InputFieldType.Text">
    <ng-container
      *ngTemplateOutlet="textAndNumberInput; context: { $implicit: type }"
    ></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.Number">
    <ng-container
      *ngTemplateOutlet="textAndNumberInput; context: { $implicit: type }"
    ></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.Time">
    <ng-container
      *ngTemplateOutlet="textAndNumberInput; context: { $implicit: type }"
    ></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.Password">
    <div class="password-container">
      <input
        [placeholder]="placeholder | allLettersCapital"
        [type]="showPassword ? 'text' : 'password'"
        class="form-control"
        [id]="inputId"
        [formControlName]="controlName"
      />
      <button
        (click)="togglePasswordVisibility()"
        class="icon-btn view-password"
      >
        <i
          [class]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"
        ></i>
      </button>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.TextArea">
    <textarea
      class="form-control"
      [formControlName]="controlName"
      cols="30"
      rows="3"
    ></textarea>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.Switch">
    <div class="switch">
      <label for="switch-input" class="form-label">{{ label | allLettersCapital}}</label>
      <p-inputSwitch
        id="switch-input"
        [formControlName]="controlName"
      ></p-inputSwitch>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.Dropdown">
    <p-dropdown
      #dropdown
      [placeholder]="placeholder | allLettersCapital"
      [options]="options"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [formControlName]="controlName"
      [autoDisplayFirst]="autoDisplayFirst"
      [filter]="showFilter"
      appendTo="body"
      (onShow)="emitScrollEnd($event)"
    ></p-dropdown>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.SearchableDropdown">
    <p-dropdown
      panelStyleClass="dropdown-panel"
      [placeholder]="placeholder | allLettersCapital"
      [options]="options"
      [optionLabel]="optionLabel"
      (onFilter)="handleSearch($event.filter)"
      [filter]="true"
      [emptyMessage]="optionsLoading ? 'Search In Progress...' : 'No Results Found'"
      [emptyFilterMessage]="optionsLoading ? 'Search In Progress...' : 'No Results Found'"
      [formControlName]="controlName"
      [filterBy]="optionLabel"
      [autoDisplayFirst]="autoDisplayFirst"
      appendTo="body"
      [optionValue]="optionValue"
      (onShow)="setPagination()"
      (onHide)="removeScrollSubscription()"
      >
      <ng-template pTemplate="footer">
        <div
          class="loading-spinner m-auto text-center"
          *ngIf="loadingMoreGroups"
        >
          Loading More
          <i *ngIf="loadingMoreGroups" class="fa-spin fas fa-spinner ms-2"></i>
        </div>
        <!-- <div class="loading-spinner m-auto text-center" *ngIf="!loadingMoreGroups  && currentPageScrolling === lastPageScrolling && options.length > 10">
                No more results.
                </div> -->
      </ng-template>
    </p-dropdown>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.SearchableMultiSelectDropdown">
    <p-multiSelect
      panelStyleClass="dropdown-panel"
      [placeholder]="placeholder | allLettersCapital"
      [options]="options"
      [optionLabel]="optionLabel"
      (onFilter)="handleSearch($event.filter)"
      [filter]="true"
      [formControlName]="controlName"
      [filterBy]="optionLabel"
      appendTo="body"
      [optionValue]="optionValue"
    ></p-multiSelect>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.SearchableMultiSelect">
    <p-multiSelect
      [placeholder]="placeholder | allLettersCapital"
      [options]="options"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [filter]="true"
      (onFilter)="handleSearch($event.filter)"
      [formControlName]="controlName"
      appendTo="body"
    ></p-multiSelect>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.MultiSelect">
    <p-multiSelect
      [placeholder]="placeholder | allLettersCapital"
      [options]="options"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [formControlName]="controlName"
      appendTo="body"
    ></p-multiSelect>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.DatePicker">
    <p-calendar
      [timeOnly]="timeOnly"
      [formControlName]="controlName"
      [showIcon]="true"
      appendTo="body"
      placeholder="Select Date"
      dateFormat="mm/dd/yy"
    ></p-calendar>
  </ng-container>
  <ng-container *ngSwitchCase="InputFieldType.Checkbox">
    <div class="checkbox" [class.show-border]="showBorder">
      <p-checkbox
        [formControlName]="controlName"
        [binary]="true"
        [inputId]="'input' + randomId"
      ></p-checkbox>
      <label [for]="'input' + randomId" class="checkbox-label-inside">
        {{ label | allLettersCapital}}
      </label>
    </div>
  </ng-container>
  <app-form-errors
    [color]="'danger'"
    [form]="form"
    [control]="form.get(controlName)"
  >
  </app-form-errors>
  <ng-template #textAndNumberInput let-fieldType>
    <input
      [id]="inputId"
      [placeholder]="placeholder | allLettersCapital"
      [type]="fieldType"
      class="form-control"
      [mask]="mask"
      [appTrimInput]="shouldTrimInput"
      [formControlName]="controlName"
    />
  </ng-template>
</div>
